import AlteracaoPossePanel from "./AlteracaoPossePanel";
import IngressoEstatutarioPanel from "./IngressoEstatutarioPanel";
import OcorrenciasGeradas from "./OcorrenciasGeradas";
import CategoriasDisponiveis, {
    referenciasParaPreparacao
} from "./CategoriasDisponiveis";
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    Chip,
    Divider,
    FormControlLabel,
    Grid,
    Icon,
    Link as MuiLink,
    Paper,
    Stack,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import {useDialog} from "muibox";
import {useState} from "react";
import {Link} from "react-router-dom";
import {
    isAnoMesValido,
    useCancelarHomologacaoAtosPessoal,
    usePrepararCargaInicialCargosFolha,
    usePrepararComplementoCargosFolha,
    usePrepararQuadroVagas,
    usePlanoAtosPessoal,
    useSituacaoCargaInicial,
    usePrepararCargosConcursoFolha,
    usePrepararComponentesFolha,
    usePrepararConcursosFolha,
    usePrepararDadosFuncionaisAtivosFolha,
    usePrepararCompetenciaFolha,
    usePrepararServidoresAtivosFolha,
    usePrepararVinculosPrevidenciariosFolha,
    useSimularAtosPessoal
} from "../../api/DpgeIntegracaoEsfingeApi";
import useFeedback from "../../components/feedback/useFeedback";
import ConjuntoFolhasSelecao from "./ConjuntoFolhasSelecao";
import DataPanel from "../../components/data/DataPanel";
import {useLoading} from "../../components/loading/LoadingProvider";
import Page from "../../components/layout/page/Page";
import PageHeader from "../../components/page-header/PageHeader";
import IconBadge from "../../components/icon-badge/IconBadge";
import Voltar from "../../components/voltar/Voltar";

const TAB_PLANO = "plano";
const TAB_PREPARACAO = "preparacao";
const TAB_CANCELAMENTO = "cancelamento";

export const ORIENTACOES_OPERACOES = Object.freeze({
    atualizarPlano:
        "Recalcula o plano técnico da competência e apresenta etapas, dependências e alertas. Não cria ocorrência nem transmite dados.",
    simularFila:
        "Registra ocorrências com massa simulada para validar o planejamento, a fila e a interface. Não representa dados reais da Folha.",
    cadastroInicialCargos:
        "Compara os cargos da Folha com os cadastros já aceitos pelo e-Sfinge e prepara somente as criações ausentes. Deve anteceder o Quadro de Vagas. Envio tempestivo: na data da publicação da lei ou ato que cria, altera ou extingue o cargo. Carga inicial: prazo definido em resolução específica. Manual 2026, item 8.1.1.",
    complementarCargos:
        "Prepara uma atualização do tipo 05 para cargo já cadastrado quando houver alteração posterior de CBO, escolaridade ou informação jurídica. Não cria cargo novo. Envio: na data do cadastramento da alteração na unidade, quando posterior ao envio principal. CBO e escolaridade devem anteceder o Quadro de Vagas. Manual 2026, item 8.1.2.",
    quadroVagas:
        "Prepara a fotografia de vagas fixadas e ocupadas no primeiro dia útil da competência, validando previamente os cargos e seus totais. Envio mensal: no primeiro dia útil do mês. Uma remessa por competência; correções exigem cancelamento prévio. Manual 2026, item 8.1.3.",
    componentes:
        "Compara as rubricas utilizadas na competência com o histórico aceito e prepara somente componentes novos ou materialmente alterados. Envio: na data da emissão da folha que utilizará a rubrica, antes da própria folha. Carga inicial: prazo definido em resolução específica. Manual 2026, item 8.1.17.",
    servidoresAtivos:
        "Prepara a fotografia cadastral dos vínculos ativos no encerramento da competência, após a conferência de cargos, vagas e componentes. Envio: na data de envio dos atos de ingresso ou movimentação, antes dos respectivos vínculos. Carga inicial: prazo definido em resolução específica. Manual 2026, item 8.1.10.",
    dadosFuncionais:
        "Prepara movimentos funcionais após o aceite do ingresso estatutário nas novas admissões; efetivos exigem também resultado e convocação do concurso. Reconcilia dependências e registros já aceitos pelo e-Sfinge. Envio tempestivo: na data do ato de movimentação do servidor. Carga inicial: prazo definido em resolução específica. Manual 2026, item 8.1.14.",
    vinculosPrevidenciarios:
        "Valida inativos e pensionistas em conjunto. Na primeira execução prepara apenas as identificações ainda ausentes; depois do aceite dessas identificações, uma nova execução prepara os vínculos previdenciários em eventos separados. Pensionistas judiciais de natureza alimentar não entram nesta carga. Envio tempestivo: na data do ato que institui, altera ou extingue a inatividade ou a pensão. Carga inicial: prazo definido em resolução específica. Manual 2026, itens 8.1.15 e 8.1.16.",
    cargosConcurso:
        "Prepara os cadastros de cargos exigidos pelo concurso informado. Essa operação deve anteceder o envio do edital e do resultado.",
    concursos:
        "Prepara os eventos disponíveis do concurso informado, como edital, resultado, reservas e prorrogação, respeitando suas dependências.",
    folha: "Prepara as categorias disponíveis da competência: normal, férias, rescisão, indenizatórias, décimos terceiros e complementares. Mostra grupos, valores e pendências para selecionar o que enviar. Cada remessa valida identificação, vínculo e componentes. A preparação não autoriza nem transmite dados. Envio: na data da emissão da folha, com a competência compatível com a liquidação do empenho. Manual 2026, item 8.1.20.",
    cancelamentos:
        "Cria ocorrências de cancelamento para alvos válidos de Atos de Pessoal. O histórico é preservado e cada cancelamento ainda exige revisão e autorização.",
    revisarCancelamento:
        "Abre a ocorrência de cancelamento preparada para conferir a origem, os dados e a autorização antes do processamento."
});

const estadoInicial = {
    anoMes: competenciaAtual(),
    incluirInativos: false,
    incluirPensionistas: false,
    incluirConcursos: false,
    referenciasComplementares: {},
    seqFolhaPagamento: "1",
    seqFolhaIndenizatoria: "2",
    tipoFolha: "1",
    categoriaFolha: "NORMAL",
    tipoServidor: "",
    anoMesCompetenciaFolhaSuplementar: "",
    codigoUnidadeOrcamentariaPadrao: "33101",
    idConcursoPublico: "",
    ocorrenciaIds: "",
    codigosRegistro: "",
    chavesPacote: "",
    justificativa: ""
};

function IntegracaoFolhaPage() {
    const [parametros, setParametros] = useState(estadoInicial);
    const [aba, setAba] = useState(TAB_PLANO);
    const [resultado, setResultado] = useState(null);
    const dialog = useDialog();
    const setLoading = useLoading();
    const {showError} = useFeedback();
    const planoQuery = usePlanoAtosPessoal(parametros.anoMes, parametros);
    const situacaoCargaQuery = useSituacaoCargaInicial(
        parametros.anoMes,
        aba === TAB_PREPARACAO
    );
    const simular = useSimularAtosPessoal();
    const prepararCargosConcurso = usePrepararCargosConcursoFolha();
    const prepararCargaInicialCargos = usePrepararCargaInicialCargosFolha();
    const prepararComplementoCargos = usePrepararComplementoCargosFolha();
    const prepararConcursos = usePrepararConcursosFolha();
    const prepararComponentes = usePrepararComponentesFolha();
    const prepararServidoresAtivos = usePrepararServidoresAtivosFolha();
    const prepararDadosFuncionaisAtivos =
        usePrepararDadosFuncionaisAtivosFolha();
    const prepararVinculosPrevidenciarios =
        usePrepararVinculosPrevidenciariosFolha();
    const prepararFolha = usePrepararCompetenciaFolha();
    const cancelarHomologacao = useCancelarHomologacaoAtosPessoal();
    const prepararQuadroVagas = usePrepararQuadroVagas();

    const anoMesInvalido = !isAnoMesValido(parametros.anoMes);

    function atualizarCampo(campo, valor) {
        setParametros((atual) => ({
            ...atual,
            [campo]: valor,
            ...(campo === "anoMes" ? {referenciasComplementares: {}} : {})
        }));
        if (campo === "anoMes") setResultado(null);
    }

    function atualizarCheckbox(campo, event) {
        atualizarCampo(campo, event.target.checked);
    }

    async function executarComConfirmacao(titulo, mutation, payload) {
        if (anoMesInvalido) {
            showError("Informe uma competência no formato AAAAMM.");
            return;
        }

        try {
            await dialog.confirm({
                title: titulo,
                ok: {text: "CONFIRMAR", color: "primary"},
                cancel: {text: "CANCELAR", color: "primary"}
            });
        } catch (error) {
            return;
        }

        setLoading(true);
        try {
            const response = await mutation.mutateAsync(payload);
            setResultado({titulo, data: response.data});
        } catch (error) {
            showError(error);
        } finally {
            setLoading(false);
        }
    }

    function handleSimular() {
        executarComConfirmacao(
            "Deseja simular o enfileiramento de Atos de Pessoal?",
            simular,
            payloadSimulacao(parametros)
        );
    }

    function handlePrepararConcursos() {
        if (!parametros.idConcursoPublico) {
            showError("Informe o identificador do concurso público.");
            return;
        }

        executarComConfirmacao(
            "Deseja preparar os concursos da Folha em fila manual?",
            prepararConcursos,
            {
                anoMes: parametros.anoMes,
                idConcursoPublico: parametros.idConcursoPublico
            }
        );
    }

    function handlePrepararCargosConcurso() {
        if (!parametros.idConcursoPublico) {
            showError("Informe o identificador do concurso público.");
            return;
        }

        executarComConfirmacao(
            "Deseja preparar os cargos exigidos pelo concurso para revisão?",
            prepararCargosConcurso,
            {
                anoMes: parametros.anoMes,
                idConcursoPublico: parametros.idConcursoPublico
            }
        );
    }

    function handlePrepararComponentes() {
        executarComConfirmacao(
            "Deseja comparar os componentes utilizados na competência com o histórico aceito e preparar somente os novos ou alterados?",
            prepararComponentes,
            parametros.anoMes
        );
    }

    function handlePrepararServidoresAtivos() {
        executarComConfirmacao(
            "Deseja validar a fotografia temporal dos servidores ativos e preparar somente as identificações ainda não aceitas pelo e-Sfinge?",
            prepararServidoresAtivos,
            parametros.anoMes
        );
    }

    function handlePrepararDadosFuncionaisAtivos(categoriaFolha) {
        const categoria =
            typeof categoriaFolha === "string" ? categoriaFolha : null;
        executarComConfirmacao(
            categoria
                ? "Preparar a fotografia funcional dos vínculos das indenizatórias? Todos os registros dessa categoria precisam estar aptos. Não haverá transmissão nesta etapa."
                : "Deseja validar ingressos e movimentações funcionais dos vínculos ativos? A carga somente será preparada se todos os registros e dependências estiverem aptos.",
            prepararDadosFuncionaisAtivos,
            categoria
                ? {anoMes: parametros.anoMes, categoriaFolha: categoria}
                : parametros.anoMes
        );
    }

    function handlePrepararVinculosPrevidenciarios() {
        executarComConfirmacao(
            "Deseja validar conjuntamente inativos e pensionistas? A preparação respeitará a identificação prévia e será bloqueada integralmente se houver inconsistência.",
            prepararVinculosPrevidenciarios,
            parametros.anoMes
        );
    }

    function handlePrepararFolha() {
        executarComConfirmacao(
            "Preparar todas as folhas disponíveis da competência para conferência e seleção, sem transmitir?",
            prepararFolha,
            {
                ...payloadConjuntoFolhaNormal(parametros),
                seqFolhaIndenizatoria: Number(parametros.seqFolhaIndenizatoria),
                referenciasComplementares: referenciasParaPreparacao(
                    parametros.referenciasComplementares
                )
            }
        );
    }

    function handlePrepararQuadroVagas() {
        executarComConfirmacao(
            "Deseja apurar o quadro de vagas do primeiro dia útil e prepará-lo para revisão?",
            prepararQuadroVagas,
            parametros.anoMes
        );
    }

    function handlePrepararCargaInicialCargos() {
        executarComConfirmacao(
            "Deseja comparar os cargos da Folha com os cadastros já aceitos e preparar somente a carga inicial faltante?",
            prepararCargaInicialCargos,
            parametros.anoMes
        );
    }

    function handlePrepararComplementoCargos() {
        executarComConfirmacao(
            "Deseja preparar correções ou complementações de CBO e escolaridade para cargos já existentes no e-Sfinge?",
            prepararComplementoCargos,
            parametros.anoMes
        );
    }

    function handleCancelarHomologacao() {
        const payload = payloadCancelamento(parametros);

        if (!payload.temAlvo) {
            showError(
                "Informe pelo menos uma ocorrência, código de registro ou chave de pacote."
            );
            return;
        }

        const {temAlvo, ...request} = payload;

        executarComConfirmacao(
            "Deseja registrar cancelamentos para a massa de homologação?",
            cancelarHomologacao,
            request
        );
    }

    return (
        <Page maxWidth="lg">
            <PageHeader
                primary="Integração Folha"
                secondary="Planejamento, preparação e cancelamento de Atos de Pessoal."
                commands={[
                    <Box key="voltar" sx={{display: {xs: "none", sm: "block"}}}>
                        <Voltar />
                    </Box>
                ]}
            />

            <ParametrosPanel
                parametros={parametros}
                anoMesInvalido={anoMesInvalido}
                onCampoChange={atualizarCampo}
                onCheckboxChange={atualizarCheckbox}
                onRefreshPlano={() => planoQuery.refetch()}
                atualizandoPlano={planoQuery.isFetching}
            />

            <Paper
                variant="outlined"
                sx={{mt: 2, borderRadius: 3, overflow: "hidden"}}
            >
                <Tabs
                    value={aba}
                    onChange={(event, value) => setAba(value)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        bgcolor: "action.hover",
                        px: 1,
                        pt: 1,
                        ".MuiTab-root": {
                            borderRadius: "10px 10px 0 0",
                            minHeight: 56,
                            px: {xs: 2, md: 3},
                            textTransform: "none",
                            fontWeight: 600
                        }
                    }}
                >
                    <Tab
                        value={TAB_PLANO}
                        label="Plano de envio"
                        icon={<Icon>account_tree</Icon>}
                        iconPosition="start"
                    />
                    <Tab
                        value={TAB_PREPARACAO}
                        label="Preparar dados"
                        icon={<Icon>playlist_add_check</Icon>}
                        iconPosition="start"
                    />
                    <Tab
                        value={TAB_CANCELAMENTO}
                        label="Cancelamentos"
                        icon={<Icon>cancel_schedule_send</Icon>}
                        iconPosition="start"
                    />
                </Tabs>
                <Divider />

                <Box sx={{p: {xs: 2, md: 3}}}>
                    {aba === TAB_PLANO && (
                        <PlanoPanel
                            planoQuery={planoQuery}
                            anoMesInvalido={anoMesInvalido}
                            parametros={parametros}
                            onSimular={handleSimular}
                        />
                    )}

                    {aba === TAB_PREPARACAO && (
                        <PreparacaoPanel
                            parametros={parametros}
                            situacaoQuery={situacaoCargaQuery}
                            onCampoChange={atualizarCampo}
                            onPrepararCargosConcurso={
                                handlePrepararCargosConcurso
                            }
                            onPrepararCargaInicialCargos={
                                handlePrepararCargaInicialCargos
                            }
                            onPrepararComplementoCargos={
                                handlePrepararComplementoCargos
                            }
                            onPrepararConcursos={handlePrepararConcursos}
                            onPrepararComponentes={handlePrepararComponentes}
                            onPrepararServidoresAtivos={
                                handlePrepararServidoresAtivos
                            }
                            onPrepararDadosFuncionaisAtivos={
                                handlePrepararDadosFuncionaisAtivos
                            }
                            onPrepararVinculosPrevidenciarios={
                                handlePrepararVinculosPrevidenciarios
                            }
                            onPrepararFolha={handlePrepararFolha}
                            onPrepararQuadroVagas={handlePrepararQuadroVagas}
                        />
                    )}

                    {aba === TAB_CANCELAMENTO && (
                        <CancelamentoPanel
                            parametros={parametros}
                            onCampoChange={atualizarCampo}
                            onCancelarHomologacao={handleCancelarHomologacao}
                        />
                    )}
                </Box>
            </Paper>

            <ResultadoOperacao resultado={resultado} />
        </Page>
    );
}

function ParametrosPanel({
    parametros,
    anoMesInvalido,
    onCampoChange,
    onCheckboxChange,
    onRefreshPlano,
    atualizandoPlano
}) {
    return (
        <Paper variant="outlined" sx={{p: {xs: 2, md: 2.5}, borderRadius: 3}}>
            <Stack
                direction={{xs: "column", sm: "row"}}
                justifyContent="space-between"
                alignItems={{sm: "center"}}
                spacing={1}
            >
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <IconBadge>calendar_month</IconBadge>
                    <Box>
                        <Typography fontWeight={700}>
                            Escopo da integração
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Defina a competência e os grupos incluídos no plano.
                        </Typography>
                    </Box>
                </Stack>
                <Chip
                    variant="outlined"
                    color={anoMesInvalido ? "error" : "primary"}
                    label={
                        anoMesInvalido
                            ? "Competência inválida"
                            : `Competência ${formatarAnoMes(parametros.anoMes)}`
                    }
                />
            </Stack>
            <Divider sx={{my: 2}} />
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4} md={2}>
                    <TextField
                        fullWidth
                        required
                        label="Competência"
                        value={parametros.anoMes}
                        error={anoMesInvalido}
                        helperText={anoMesInvalido ? "Use AAAAMM" : " "}
                        inputProps={{maxLength: 6}}
                        onChange={(event) =>
                            onCampoChange(
                                "anoMes",
                                onlyNumbers(event.target.value)
                            )
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={8} md={7}>
                    <Stack
                        direction={{xs: "column", sm: "row"}}
                        spacing={{xs: 0, sm: 2}}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={parametros.incluirInativos}
                                    onChange={(event) =>
                                        onCheckboxChange(
                                            "incluirInativos",
                                            event
                                        )
                                    }
                                />
                            }
                            label="Inativos"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={parametros.incluirPensionistas}
                                    onChange={(event) =>
                                        onCheckboxChange(
                                            "incluirPensionistas",
                                            event
                                        )
                                    }
                                />
                            }
                            label="Pensionistas"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={parametros.incluirConcursos}
                                    onChange={(event) =>
                                        onCheckboxChange(
                                            "incluirConcursos",
                                            event
                                        )
                                    }
                                />
                            }
                            label="Concursos"
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BotaoOperacao
                        orientacao={ORIENTACOES_OPERACOES.atualizarPlano}
                        fullWidth
                        variant="outlined"
                        size="large"
                        startIcon={<Icon>refresh</Icon>}
                        sx={{height: 56}}
                        onClick={onRefreshPlano}
                        disabled={anoMesInvalido || atualizandoPlano}
                    >
                        Atualizar plano
                    </BotaoOperacao>
                </Grid>
            </Grid>
        </Paper>
    );
}

function PlanoPanel({planoQuery, anoMesInvalido, parametros, onSimular}) {
    const plano = planoQuery.data || {};
    const etapas = plano.etapas || [];
    const quantidadeObrigatorias = etapas.filter(
        (etapa) => etapa.obrigatoriaParaFolha
    ).length;

    if (anoMesInvalido) {
        return (
            <Alert severity="warning">Informe uma competência válida.</Alert>
        );
    }

    if (planoQuery.isError) {
        return <Alert severity="error">{mensagemErro(planoQuery.error)}</Alert>;
    }

    return (
        <DataPanel loading={planoQuery.isLoading}>
            <Stack spacing={2}>
                <Alert severity="info">
                    Novas admissões: identificação e cargo aceitos → concurso e
                    convocação para efetivos → ingresso estatutário → vínculos e
                    movimentos → pagamento. Comissionados estatutários não
                    exigem concurso. Essas etapas condicionais não repetem
                    registros já aceitos na carga mensal.
                </Alert>
                <Grid container spacing={1} alignItems="center">
                    <Grid item>
                        <Chip
                            variant="outlined"
                            label={`Competência ${formatarAnoMes(
                                plano.anoMes || parametros.anoMes
                            )}`}
                        />
                    </Grid>
                    {plano.dataFatoGerador && (
                        <Grid item>
                            <Chip
                                variant="outlined"
                                label={`Fato gerador ${formatarData(
                                    plano.dataFatoGerador
                                )}`}
                            />
                        </Grid>
                    )}
                    <Grid item>
                        <Chip
                            label={`${etapas.length} etapas`}
                            color="primary"
                        />
                    </Grid>
                    <Grid item>
                        <Chip
                            label={`${quantidadeObrigatorias} obrigatórias`}
                            color="secondary"
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} md="auto" sx={{ml: {md: "auto"}}}>
                        <BotaoOperacao
                            orientacao={ORIENTACOES_OPERACOES.simularFila}
                            fullWidth
                            variant="contained"
                            onClick={onSimular}
                        >
                            Simular fila
                        </BotaoOperacao>
                    </Grid>
                </Grid>

                <MensagensLista titulo="Alertas" mensagens={plano.alertas} />

                <EtapasMobileList etapas={etapas} />
                <Box sx={{display: {xs: "none", md: "block"}}}>
                    <TableContainer sx={{maxWidth: "100%", overflowX: "auto"}}>
                        <Table size="small">
                            <TableHead sx={{bgcolor: "action.hover"}}>
                                <TableRow>
                                    <TableCell>Ordem</TableCell>
                                    <TableCell>Fase</TableCell>
                                    <TableCell>Evento</TableCell>
                                    <TableCell>Estratégia</TableCell>
                                    <TableCell>Obrigatória</TableCell>
                                    <TableCell>Dependências</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {etapas.map((etapa) => (
                                    <TableRow
                                        hover
                                        key={`${etapa.ordem}-${etapa.evento}`}
                                    >
                                        <TableCell>{etapa.ordem}</TableCell>
                                        <TableCell>{etapa.fase}</TableCell>
                                        <TableCell>
                                            <Typography
                                                variant="body2"
                                                fontWeight={500}
                                            >
                                                {etapa.evento}
                                            </Typography>
                                            {etapa.descricao && (
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                >
                                                    {etapa.descricao}
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {etapa.estrategiaEnvio}
                                        </TableCell>
                                        <TableCell>
                                            {etapa.obrigatoriaParaFolha
                                                ? "Sim"
                                                : "Não"}
                                        </TableCell>
                                        <TableCell>
                                            <DependenciasList
                                                dependencias={etapa.dependeDe}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Stack>
        </DataPanel>
    );
}

function EtapasMobileList({etapas}) {
    return (
        <Stack spacing={1.5} sx={{display: {xs: "flex", md: "none"}}}>
            {etapas.map((etapa) => (
                <Box
                    key={`${etapa.ordem}-${etapa.evento}`}
                    sx={{
                        borderTop: "1px solid",
                        borderColor: "divider",
                        pt: 1.5
                    }}
                >
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            <Chip size="small" label={`Ordem ${etapa.ordem}`} />
                            <Chip
                                size="small"
                                variant="outlined"
                                label={etapa.estrategiaEnvio}
                            />
                            {etapa.obrigatoriaParaFolha && (
                                <Chip
                                    size="small"
                                    color="secondary"
                                    variant="outlined"
                                    label="Obrigatória"
                                />
                            )}
                        </Stack>
                        <Box>
                            <Typography variant="body2" fontWeight={500}>
                                {etapa.evento}
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                {etapa.fase}
                            </Typography>
                        </Box>
                        {etapa.descricao && (
                            <Typography variant="body2">
                                {etapa.descricao}
                            </Typography>
                        )}
                        <DependenciasList dependencias={etapa.dependeDe} />
                    </Stack>
                </Box>
            ))}
        </Stack>
    );
}

export function PreparacaoPanel({
    parametros,
    situacaoQuery = {},
    onCampoChange,
    onPrepararCargosConcurso,
    onPrepararCargaInicialCargos,
    onPrepararComplementoCargos,
    onPrepararConcursos,
    onPrepararComponentes,
    onPrepararServidoresAtivos,
    onPrepararDadosFuncionaisAtivos,
    onPrepararVinculosPrevidenciarios,
    onPrepararFolha,
    onPrepararQuadroVagas
}) {
    const [ingressoAberto, setIngressoAberto] = useState(false);
    const situacao =
        situacaoQuery.data?.anoMes === parametros.anoMes
            ? situacaoQuery.data
            : null;
    const verificando = !situacao || situacaoQuery.isError;
    const orientacaoPendente = situacaoQuery.isError
        ? "Não foi possível conferir o histórico. Atualize a consulta antes de preparar esta carga."
        : "Aguarde a conferência dos cadastros já aceitos.";
    const cargosConcluidos = situacao?.cargosConcluidos;
    const quadroConcluido = Boolean(situacao?.ocorrenciaQuadroVagasAceitoId);
    const dataQuadro = situacao?.dataPrevistaQuadroVagas
        ?.split("-")
        .reverse()
        .join("/");
    return (
        <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} md={ingressoAberto ? 12 : 5}>
                <Stack spacing={2}>
                    <Card variant="outlined" sx={{borderRadius: 3}}>
                        <CardContent>
                            <Stack spacing={2}>
                                <OperacaoHeader
                                    icone="inventory"
                                    titulo="Carga inicial/Tempestiva"
                                    descricao="Cadastros iniciais e atualizações conforme a ocorrência dos atos."
                                />
                                <Alert severity="info">
                                    Siga a ordem abaixo. Antes de avançar para
                                    uma etapa dependente, confira o aceite da
                                    anterior. A preparação mantém os dados para
                                    revisão; o envio exige autorização
                                    explícita. Cargas concluídas ficam
                                    bloqueadas. As atualizações tempestivas
                                    continuam disponíveis para novos atos.
                                </Alert>
                                {situacaoQuery.isError && (
                                    <Alert
                                        severity="error"
                                        action={
                                            <Button
                                                onClick={() =>
                                                    situacaoQuery.refetch()
                                                }
                                            >
                                                Atualizar
                                            </Button>
                                        }
                                    >
                                        Falha ao conferir as cargas já aceitas.
                                        A preparação de cargos e quadro de vagas
                                        aguarda essa conferência.
                                    </Alert>
                                )}
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.cadastroInicialCargos +
                                        " " +
                                        (verificando
                                            ? orientacaoPendente
                                            : cargosConcluidos
                                            ? "Carga inicial concluída: " +
                                              situacao.quantidadeCargosAceitos +
                                              " de " +
                                              situacao.quantidadeCargos +
                                              " cargos aceitos. Não há cargos novos para preparar."
                                            : "Há cargos ainda não aceitos no e-Sfinge.")
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={<Icon>inventory_2</Icon>}
                                    disabled={verificando || cargosConcluidos}
                                    onClick={onPrepararCargaInicialCargos}
                                >
                                    1. Preparar cadastro inicial de cargos
                                </BotaoOperacao>
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.complementarCargos
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={<Icon>rule</Icon>}
                                    onClick={onPrepararComplementoCargos}
                                >
                                    1.1. Complementar cargos, se necessário
                                </BotaoOperacao>
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.quadroVagas +
                                        " " +
                                        (dataQuadro
                                            ? "Data prevista para esta competência: " +
                                              dataQuadro +
                                              ". "
                                            : "") +
                                        (verificando
                                            ? orientacaoPendente
                                            : quadroConcluido
                                            ? "Já aceito na ocorrência " +
                                              situacao.ocorrenciaQuadroVagasAceitoId +
                                              ". Para corrigir, cancele a remessa anterior e aguarde a confirmação."
                                            : "Ainda não há remessa aceita para esta competência.")
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={<Icon>account_balance</Icon>}
                                    disabled={verificando || quadroConcluido}
                                    onClick={onPrepararQuadroVagas}
                                >
                                    2. Preparar quadro de vagas
                                </BotaoOperacao>
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.componentes
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={
                                        <Icon>format_list_numbered</Icon>
                                    }
                                    onClick={onPrepararComponentes}
                                >
                                    3. Preparar componentes da folha
                                </BotaoOperacao>
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.servidoresAtivos
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={<Icon>groups</Icon>}
                                    onClick={onPrepararServidoresAtivos}
                                >
                                    4. Preparar identificação dos servidores
                                </BotaoOperacao>
                                <Card variant="outlined" sx={{borderRadius: 3}}>
                                    <CardContent>
                                        <Stack spacing={2}>
                                            <OperacaoHeader
                                                icone="school"
                                                titulo="4.1. Concursos, quando aplicável"
                                                descricao="Prepare primeiro os cargos exigidos; depois, edital, resultado e demais ocorrências vinculadas."
                                            />
                                            <TextField
                                                fullWidth
                                                label="ID do concurso público"
                                                value={
                                                    parametros.idConcursoPublico
                                                }
                                                onChange={(event) =>
                                                    onCampoChange(
                                                        "idConcursoPublico",
                                                        onlyNumbers(
                                                            event.target.value
                                                        )
                                                    )
                                                }
                                            />
                                            <BotaoOperacao
                                                orientacao={
                                                    ORIENTACOES_OPERACOES.cargosConcurso
                                                }
                                                fullWidth
                                                sx={{
                                                    justifyContent:
                                                        "flex-start",
                                                    textAlign: "left"
                                                }}
                                                variant="outlined"
                                                startIcon={<Icon>badge</Icon>}
                                                onClick={
                                                    onPrepararCargosConcurso
                                                }
                                            >
                                                Preparar cargos do concurso
                                            </BotaoOperacao>
                                            <BotaoOperacao
                                                orientacao={
                                                    ORIENTACOES_OPERACOES.concursos
                                                }
                                                fullWidth
                                                variant="contained"
                                                startIcon={
                                                    <Icon>playlist_add</Icon>
                                                }
                                                onClick={onPrepararConcursos}
                                            >
                                                Preparar concursos
                                            </BotaoOperacao>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                <Button
                                    variant="outlined"
                                    startIcon={<Icon>assignment_ind</Icon>}
                                    onClick={() =>
                                        setIngressoAberto(!ingressoAberto)
                                    }
                                    aria-expanded={ingressoAberto}
                                >
                                    4.2–4.3. Convocação, alteração da posse e
                                    ingresso
                                </Button>
                                {ingressoAberto && (
                                    <Stack spacing={3} key={parametros.anoMes}>
                                        <AlteracaoPossePanel
                                            anoMes={parametros.anoMes}
                                        />
                                        <IngressoEstatutarioPanel
                                            key={parametros.anoMes}
                                            anoMes={parametros.anoMes}
                                        />
                                    </Stack>
                                )}
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.dadosFuncionais
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={<Icon>manage_accounts</Icon>}
                                    onClick={onPrepararDadosFuncionaisAtivos}
                                >
                                    5. Preparar vínculos e movimentos funcionais
                                </BotaoOperacao>
                                <BotaoOperacao
                                    orientacao={
                                        ORIENTACOES_OPERACOES.vinculosPrevidenciarios
                                    }
                                    fullWidth
                                    sx={{
                                        justifyContent: "flex-start",
                                        textAlign: "left"
                                    }}
                                    variant="outlined"
                                    startIcon={<Icon>elderly</Icon>}
                                    onClick={onPrepararVinculosPrevidenciarios}
                                >
                                    6. Preparar inativos e pensionistas
                                </BotaoOperacao>
                                <MuiLink
                                    href="https://www.tce.ms.gov.br/portaljurisdicionado/files/conteudos/arquivo/1052/e153e977b513820b55c02680fea30a033ea14e51d53f245a2b6231d112730000.pdf#page=222"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    variant="caption"
                                >
                                    Consultar prazos no Manual e-Sfinge 2026
                                </MuiLink>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Grid>

            <Grid item xs={12} md={ingressoAberto ? 12 : 7}>
                <Card variant="outlined" sx={{height: "100%", borderRadius: 3}}>
                    <CardContent>
                        <Stack spacing={2}>
                            <OperacaoHeader
                                icone="payments"
                                titulo="7. Folhas da competência"
                                descricao="Consulte as folhas da competência e selecione quais deseja enviar."
                            />
                            <Alert severity="info">
                                Prepare as folhas disponíveis, confira os
                                valores e selecione o que deseja enviar. O
                                conector define automaticamente os tipos e as
                                sequências exigidos pelo e-Sfinge para cada
                                remessa.
                            </Alert>
                            <TextField
                                fullWidth
                                label="Unidade orçamentária padrão"
                                helperText="UO da despesa (padrão 33101). A unidade gestora identifica o órgão no e-Sfinge e é configurada separadamente no backend."
                                value={
                                    parametros.codigoUnidadeOrcamentariaPadrao
                                }
                                onChange={(event) =>
                                    onCampoChange(
                                        "codigoUnidadeOrcamentariaPadrao",
                                        event.target.value
                                    )
                                }
                            />
                            <CategoriasDisponiveis
                                anoMes={parametros.anoMes}
                                referencias={
                                    parametros.referenciasComplementares
                                }
                                onChange={(valor) =>
                                    onCampoChange(
                                        "referenciasComplementares",
                                        valor
                                    )
                                }
                            />
                            <BotaoOperacao
                                orientacao={ORIENTACOES_OPERACOES.folha}
                                variant="contained"
                                startIcon={<Icon>send</Icon>}
                                onClick={onPrepararFolha}
                            >
                                Preparar folhas disponíveis da competência
                            </BotaoOperacao>
                            <Alert severity="info">
                                A preparação não transmite dados. Folhas já
                                aceitas são preservadas; pendências e valores
                                aparecem no resultado para conferência. Esta
                                operação atende as nove categorias da Folha,
                                incluindo décimos terceiros e complementares.
                                Confira a referência das complementares antes de
                                preparar. As sequências são estáveis por
                                categoria.
                            </Alert>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}

function OperacaoHeader({icone, titulo, descricao}) {
    return (
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
            <IconBadge>{icone}</IconBadge>
            <Box>
                <Typography variant="h6">{titulo}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {descricao}
                </Typography>
            </Box>
        </Stack>
    );
}

export function BotaoOperacao({orientacao, fullWidth, children, ...props}) {
    return (
        <Tooltip title={orientacao} arrow describeChild>
            <Box
                component="span"
                tabIndex={props.disabled ? 0 : undefined}
                sx={{
                    display: fullWidth ? "flex" : "inline-flex",
                    width: fullWidth ? "100%" : "auto"
                }}
            >
                <Button fullWidth={fullWidth} {...props}>
                    {children}
                </Button>
            </Box>
        </Tooltip>
    );
}

function CancelamentoPanel({parametros, onCampoChange, onCancelarHomologacao}) {
    return (
        <Paper variant="outlined" sx={{borderRadius: 3, p: {xs: 2, md: 3}}}>
            <Stack spacing={2.5}>
                <OperacaoHeader
                    icone="cancel_schedule_send"
                    titulo="Registrar cancelamentos"
                    descricao="Informe um ou vários alvos. Separe os valores por linha, vírgula ou ponto e vírgula."
                />
                <Alert severity="info">
                    Informe somente identificadores classificados como Atos de
                    Pessoal em Serviços Gerais. Antes de criar qualquer
                    cancelamento, o backend confirma a ocorrência de origem no
                    histórico local e bloqueia alvos financeiros, ambíguos ou
                    não identificados. Registros já cancelados serão informados
                    e ignorados; os demais registros válidos continuarão sendo
                    preparados.
                </Alert>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <CampoListaCancelamento
                            label="IDs de ocorrência"
                            value={parametros.ocorrenciaIds}
                            onChange={(value) =>
                                onCampoChange("ocorrenciaIds", value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CampoListaCancelamento
                            label="Códigos de registro"
                            value={parametros.codigosRegistro}
                            onChange={(value) =>
                                onCampoChange("codigosRegistro", value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CampoListaCancelamento
                            label="Chaves de pacote"
                            value={parametros.chavesPacote}
                            onChange={(value) =>
                                onCampoChange("chavesPacote", value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Justificativa"
                            value={parametros.justificativa}
                            onChange={(event) =>
                                onCampoChange(
                                    "justificativa",
                                    event.target.value
                                )
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <BotaoOperacao
                            orientacao={ORIENTACOES_OPERACOES.cancelamentos}
                            fullWidth
                            size="large"
                            color="error"
                            variant="contained"
                            startIcon={<Icon>cancel</Icon>}
                            onClick={onCancelarHomologacao}
                        >
                            Registrar cancelamentos
                        </BotaoOperacao>
                    </Grid>
                </Grid>
            </Stack>
        </Paper>
    );
}

function CampoListaCancelamento({label, value, onChange}) {
    const total = parseList(value).length;

    return (
        <TextField
            fullWidth
            label={label}
            value={value}
            helperText={`Total: ${total} ${
                total === 1 ? "registro informado" : "registros informados"
            }`}
            inputProps={{
                title: value,
                style: {
                    overflowX: "auto",
                    whiteSpace: "nowrap"
                }
            }}
            onChange={(event) => onChange(event.target.value)}
        />
    );
}

export function ResultadoOperacao({resultado}) {
    const data = resultado?.data;
    const ocorrencias = data?.ocorrencias || [];
    const cancelamentos = data?.cancelamentos || [];
    const ehResultadoCancelamento = Array.isArray(data?.cancelamentos);
    const titulo = ehResultadoCancelamento
        ? "Resultado da preparação de cancelamentos"
        : Array.isArray(data?.folhas)
        ? "Resultado da preparação das folhas da competência"
        : resultado?.titulo;

    if (!resultado) {
        return null;
    }

    return (
        <Paper variant="outlined" sx={{mt: 2, p: 2, borderRadius: 3}}>
            <Stack spacing={2}>
                <Typography variant="subtitle1">{titulo}</Typography>
                <Grid container spacing={1}>
                    {metricasResultado(data).map((metrica) => (
                        <Grid item key={metrica.label}>
                            <Chip
                                variant="outlined"
                                label={`${metrica.label}: ${metrica.valor}`}
                            />
                        </Grid>
                    ))}
                </Grid>
                <TiposServidorResumo
                    quantidades={data?.quantidadePorTipoServidor}
                />
                <TiposMovimentacaoResumo
                    quantidades={data?.quantidadePorTipoMovimentacao}
                />
                <VinculosPrevidenciariosResumo data={data} />
                <MensagensLista
                    titulo={
                        ehResultadoCancelamento
                            ? "Registros não preparados"
                            : "Alertas"
                    }
                    mensagens={data?.alertas}
                    severity={ehResultadoCancelamento ? "info" : "warning"}
                />
                <MensagensLista
                    titulo="Melhorias"
                    mensagens={data?.melhorias}
                    severity="info"
                />
                <MensagensLista
                    titulo="Pendências que impediram a preparação"
                    mensagens={data?.pendencias}
                    severity="error"
                />
                {Array.isArray(data?.folhas) && (
                    <ConjuntoFolhasSelecao data={data} />
                )}
                <OcorrenciasGeradas ocorrencias={ocorrencias} />
                <CancelamentosGerados cancelamentos={cancelamentos} />
            </Stack>
        </Paper>
    );
}

function VinculosPrevidenciariosResumo({data}) {
    if (!data?.inativos && !data?.pensionistas) {
        return null;
    }

    const etapa = {
        IDENTIFICACOES: "Identificações preparadas",
        VINCULOS: "Vínculos previdenciários preparados",
        NENHUMA: "Nenhuma ocorrência preparada"
    }[data.etapaPreparada];

    return (
        <Stack spacing={1.5}>
            {etapa && (
                <Alert severity="info">
                    <Typography variant="body2" fontWeight={600}>
                        Etapa desta execução: {etapa}
                    </Typography>
                    <Typography variant="body2">
                        Quando houver identificações novas, aguarde o aceite e
                        execute novamente para preparar os vínculos de inativos
                        e pensionistas.
                    </Typography>
                </Alert>
            )}
            <Grid container spacing={1.5}>
                <VinculoPrevidenciarioGrupo
                    titulo="Inativos"
                    grupo={data.inativos}
                    icone="elderly"
                />
                <VinculoPrevidenciarioGrupo
                    titulo="Pensionistas previdenciários"
                    grupo={data.pensionistas}
                    icone="family_restroom"
                />
            </Grid>
            {data.quantidadePensionistasJudiciaisExcluidos > 0 && (
                <Alert severity="warning">
                    {data.quantidadePensionistasJudiciaisExcluidos} pensionista
                    {data.quantidadePensionistasJudiciaisExcluidos === 1
                        ? " judicial foi excluído"
                        : "s judiciais foram excluídos"}{" "}
                    desta carga porque representam beneficiários de pensão
                    alimentícia, não vínculos previdenciários da Tabela 80.
                </Alert>
            )}
        </Stack>
    );
}

function VinculoPrevidenciarioGrupo({titulo, grupo, icone}) {
    if (!grupo) {
        return null;
    }

    return (
        <Grid item xs={12} md={6}>
            <Card variant="outlined" sx={{borderRadius: 2, height: "100%"}}>
                <CardContent>
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Icon color="primary">{icone}</Icon>
                            <Typography variant="subtitle2" fontWeight={600}>
                                {titulo}
                            </Typography>
                        </Stack>
                        <Stack direction="row" sx={{gap: 1, flexWrap: "wrap"}}>
                            <Chip
                                size="small"
                                label={`Fonte: ${grupo.quantidadeFonte}`}
                            />
                            <Chip
                                size="small"
                                variant="outlined"
                                label={`Novos: ${grupo.quantidadeNovos}`}
                            />
                            <Chip
                                size="small"
                                variant="outlined"
                                label={`Já sincronizados: ${grupo.quantidadeJaSincronizados}`}
                            />
                            <Chip
                                size="small"
                                variant="outlined"
                                color={
                                    grupo.quantidadeDivergentes
                                        ? "error"
                                        : "default"
                                }
                                label={`Divergentes: ${grupo.quantidadeDivergentes}`}
                            />
                            <Chip
                                size="small"
                                variant="outlined"
                                color="primary"
                                label={`Para envio: ${grupo.quantidadeParaEnvio}`}
                            />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </Grid>
    );
}

function TiposServidorResumo({quantidades}) {
    const entradas = Object.entries(quantidades || {});
    if (!entradas.length) {
        return null;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary">
                Composição da fotografia por tipo de vínculo
            </Typography>
            <Stack direction="row" sx={{gap: 1, flexWrap: "wrap"}}>
                {entradas.map(([tipo, quantidade]) => (
                    <Chip
                        key={tipo}
                        size="small"
                        variant="outlined"
                        label={`${formatarTipoServidor(tipo)}: ${quantidade}`}
                    />
                ))}
            </Stack>
        </Box>
    );
}

function TiposMovimentacaoResumo({quantidades}) {
    const entradas = Object.entries(quantidades || {});
    if (!entradas.length) {
        return null;
    }

    return (
        <Box>
            <Typography variant="caption" color="text.secondary">
                Composição da carga por tipo de movimentação
            </Typography>
            <Stack direction="row" sx={{gap: 1, flexWrap: "wrap"}}>
                {entradas.map(([tipo, quantidade]) => (
                    <Chip
                        key={tipo}
                        size="small"
                        variant="outlined"
                        label={`${formatarTipoMovimentacao(
                            tipo
                        )}: ${quantidade}`}
                    />
                ))}
            </Stack>
        </Box>
    );
}

function MensagensLista({titulo, mensagens = [], severity = "warning"}) {
    if (!mensagens?.length) {
        return null;
    }

    return (
        <Alert severity={severity}>
            <Typography variant="body2" fontWeight={500}>
                {titulo}
            </Typography>
            <Box component="ul" sx={{my: 0, pl: 2}}>
                {mensagens.map((mensagem, index) => (
                    <li key={`${mensagem}-${index}`}>{mensagem}</li>
                ))}
            </Box>
        </Alert>
    );
}

export function CancelamentosGerados({cancelamentos = []}) {
    if (!cancelamentos.length) {
        return null;
    }

    return (
        <Stack spacing={1.5}>
            <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                    Cancelamentos preparados
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Confira a ocorrência de origem e abra o cancelamento para
                    revisar os dados e o destino antes da autorização.
                </Typography>
            </Box>
            {cancelamentos.map((cancelamento) => {
                const ocorrenciaCancelamento =
                    cancelamento.ocorrenciaCancelamento || {};
                const identificador =
                    cancelamento.codigoRegistroInformacao ||
                    cancelamento.chavePacote;
                const tipoIdentificador = cancelamento.codigoRegistroInformacao
                    ? "Código de registro"
                    : "Chave do pacote";

                return (
                    <Card
                        key={
                            ocorrenciaCancelamento.id ||
                            `${cancelamento.ocorrenciaOrigemId}-${identificador}`
                        }
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            borderLeftWidth: 4,
                            borderLeftColor: "error.main"
                        }}
                    >
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack
                                    direction={{xs: "column", sm: "row"}}
                                    spacing={1.5}
                                    justifyContent="space-between"
                                    alignItems={{sm: "center"}}
                                >
                                    <Stack direction="row" spacing={1.5}>
                                        <Box
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: 1.5,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "error.main",
                                                bgcolor: "status.error"
                                            }}
                                        >
                                            <Icon>cancel_schedule_send</Icon>
                                        </Box>
                                        <Box>
                                            <Typography fontWeight={600}>
                                                Cancelamento #
                                                {ocorrenciaCancelamento.id}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                {formatarEvento(
                                                    cancelamento.eventoCancelamento
                                                )}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    <Chip
                                        size="small"
                                        color="warning"
                                        variant="outlined"
                                        label={formatarEstado(
                                            ocorrenciaCancelamento.estadoEnvio
                                        )}
                                    />
                                </Stack>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={5}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            Ocorrência de origem
                                        </Typography>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            alignItems="center"
                                            flexWrap="wrap"
                                        >
                                            <MuiLink
                                                component={Link}
                                                to={`/eventos/${cancelamento.ocorrenciaOrigemId}`}
                                                underline="hover"
                                                fontWeight={600}
                                            >
                                                #
                                                {
                                                    cancelamento.ocorrenciaOrigemId
                                                }
                                            </MuiLink>
                                            <Typography variant="body2">
                                                {formatarEvento(
                                                    cancelamento.eventoOrigem
                                                )}
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} md={7}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            {tipoIdentificador}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            fontFamily="monospace"
                                            sx={{overflowWrap: "anywhere"}}
                                        >
                                            {identificador || "Não informado"}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Box>
                                    <BotaoOperacao
                                        orientacao={
                                            ORIENTACOES_OPERACOES.revisarCancelamento
                                        }
                                        component={Link}
                                        to={`/eventos/${ocorrenciaCancelamento.id}`}
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        startIcon={<Icon>fact_check</Icon>}
                                    >
                                        Revisar cancelamento
                                    </BotaoOperacao>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                );
            })}
        </Stack>
    );
}

function formatarEstado(estado) {
    if (!estado) {
        return "Estado não informado";
    }
    return estado.replaceAll("_", " ");
}

function formatarEvento(evento) {
    const rotulos = {
        CANCELAR_TRANSMISSAO_POR_CODIGO_REGISTRO:
            "Cancelamento por código de registro",
        CANCELAR_TRANSMISSAO_ENVIO_PARCIAL: "Cancelamento de envio parcial",
        ATUALIZACAO_CARGO: "Atualização de cargo",
        ATUALIZACAO_CARGO_COMPLEMENTO: "Complemento da atualização de cargo",
        COMPONENTE_FOLHA_PAGAMENTO: "Componente da folha de pagamento",
        QUADRO_VAGAS: "Quadro de vagas",
        SERVIDORES_FINALIZAR: "Servidores",
        DADOS_FUNCIONAIS_ATIVOS_FINALIZAR: "Dados funcionais ativos",
        FOLHA_PAGAMENTO_FINALIZAR: "Folha de pagamento",
        INATIVOS_FINALIZAR: "Inativos",
        PENSIONISTAS_FINALIZAR: "Pensionistas"
    };

    return (
        rotulos[evento] ||
        `${evento || "Evento não informado"}`.replaceAll("_", " ")
    );
}

function DependenciasList({dependencias = []}) {
    if (!dependencias.length) {
        return <Typography variant="caption">Sem dependências</Typography>;
    }

    return (
        <Stack direction="row" flexWrap="wrap" gap={0.5}>
            {dependencias.map((dependencia) => (
                <Chip
                    key={dependencia}
                    size="small"
                    variant="outlined"
                    label={dependencia}
                />
            ))}
        </Stack>
    );
}

export function payloadSimulacao(parametros) {
    return {
        anoMes: parametros.anoMes,
        seqFolhaPagamento: toOptionalNumber(parametros.seqFolhaPagamento),
        tipoFolha: toOptionalNumber(parametros.tipoFolha),
        incluirInativos: parametros.incluirInativos,
        incluirPensionistas: parametros.incluirPensionistas,
        incluirConcursos: parametros.incluirConcursos
    };
}

export function payloadFolha(parametros) {
    return {
        anoMes: parametros.anoMes,
        seqFolhaPagamento: toOptionalNumber(parametros.seqFolhaPagamento),
        tipoFolha: toOptionalNumber(parametros.tipoFolha),
        categoriaFolha: parametros.categoriaFolha,
        tipoServidor: parametros.tipoServidor.trim() || undefined,
        anoMesCompetenciaFolhaSuplementar: toOptionalNumber(
            parametros.anoMesCompetenciaFolhaSuplementar
        ),
        codigoUnidadeOrcamentariaPadrao:
            parametros.codigoUnidadeOrcamentariaPadrao.trim() || undefined
    };
}

export function payloadConjuntoFolhaNormal(parametros) {
    return {
        anoMes: parametros.anoMes,
        seqFolhaPagamento: toOptionalNumber(parametros.seqFolhaPagamento),
        codigoUnidadeOrcamentariaPadrao:
            parametros.codigoUnidadeOrcamentariaPadrao.trim() || undefined
    };
}

export function payloadCancelamento(parametros) {
    const ocorrenciaIds = parseList(parametros.ocorrenciaIds)
        .map((value) => Number(value))
        .filter((value) => !Number.isNaN(value));
    const codigosRegistro = parseList(parametros.codigosRegistro);
    const chavesPacote = parseList(parametros.chavesPacote);

    return {
        ocorrenciaIds,
        codigosRegistro,
        chavesPacote,
        justificativa: parametros.justificativa.trim(),
        temAlvo:
            ocorrenciaIds.length > 0 ||
            codigosRegistro.length > 0 ||
            chavesPacote.length > 0
    };
}

export function parseList(value) {
    return `${value || ""}`
        .split(/[\n,;]/)
        .map((item) => item.trim())
        .filter(Boolean);
}

function metricasResultado(data) {
    if (!data) {
        return [];
    }

    return [
        {label: "Ocorrências", valor: data.ocorrencias?.length},
        {label: "Cancelamentos", valor: data.cancelamentos?.length},
        {
            label: "Componentes utilizados",
            valor: data.quantidadeComponentes
        },
        {
            label: "Componentes novos",
            valor: data.quantidadeComponentesNovos
        },
        {
            label: "Componentes alterados",
            valor: data.quantidadeComponentesAlterados
        },
        {
            label: "Já sincronizados",
            valor: data.quantidadeComponentesJaSincronizados
        },
        {
            label: "Componentes para envio",
            valor: data.quantidadeComponentesParaEnvio
        },
        {label: "Cargos", valor: data.quantidadeCargos},
        {label: "Atos legais", valor: data.quantidadeAtosLegais},
        {
            label: "Cargos já cadastrados",
            valor: data.quantidadeJaCadastrados
        },
        {
            label: "Cadastro por ato principal",
            valor: data.quantidadePreparadosEventoPrincipal
        },
        {
            label: "Cadastro por complemento",
            valor: data.quantidadePreparadosComplemento
        },
        {label: "CBO explícito", valor: data.quantidadeCboExplicito},
        {label: "CBO institucional", valor: data.quantidadeCboInferido},
        {
            label: "Escolaridade explícita",
            valor: data.quantidadeEscolaridadeExplicita
        },
        {
            label: "Escolaridade institucional",
            valor: data.quantidadeEscolaridadeInferida
        },
        {
            label: Array.isArray(data?.folhas)
                ? "Participações nas folhas"
                : "Servidores",
            valor: data.quantidadeServidores
        },
        {
            label: "Servidores novos",
            valor: data.quantidadeServidoresNovos
        },
        {
            label: "Servidores já sincronizados",
            valor: data.quantidadeServidoresJaSincronizados
        },
        {
            label: "Servidores divergentes",
            valor: data.quantidadeServidoresDivergentes
        },
        {
            label: "Servidores para envio",
            valor: data.quantidadeServidoresParaEnvio
        },
        {
            label: "Identificações previdenciárias",
            valor: data.quantidadeIdentificacoes
        },
        {
            label: "Identificações novas",
            valor: data.quantidadeIdentificacoesNovas
        },
        {
            label: "Identificações já sincronizadas",
            valor: data.quantidadeIdentificacoesJaSincronizadas
        },
        {
            label: "Identificações divergentes",
            valor: data.quantidadeIdentificacoesDivergentes
        },
        {label: "Vínculos", valor: data.quantidadeVinculos},
        {
            label: "Ingressos",
            valor: data.quantidadeIngressos
        },
        {
            label: "Movimentações complementares",
            valor: data.quantidadeMovimentacoesComplementares
        },
        {
            label: "Registros inaptos",
            valor: data.quantidadeRegistrosInaptos
        },
        {
            label: "Registros novos",
            valor: data.quantidadeRegistrosNovos
        },
        {
            label: "Registros já sincronizados",
            valor: data.quantidadeRegistrosJaSincronizados
        },
        {
            label: "Registros divergentes",
            valor: data.quantidadeRegistrosDivergentes
        },
        {
            label: "Registros para envio",
            valor: data.quantidadeRegistrosParaEnvio
        },
        {label: "Lançamentos", valor: data.quantidadeLancamentos},
        {
            label:
                data.quantidadeIngressos === undefined
                    ? "Registros do quadro"
                    : "Registros funcionais",
            valor: data.quantidadeRegistros
        },
        {label: "Vagas fixadas", valor: data.quantidadeFixadaLei},
        {label: "Vagas ocupadas", valor: data.quantidadeVagasOcupadas},
        {label: "Quadro geral", valor: data.quantidadeQuadroGeral},
        {label: "Quadro específico", valor: data.quantidadeQuadroEspecifico},
        {label: "Quadro especial", valor: data.quantidadeQuadroEspecial},
        {
            label: "Data de referência",
            valor: data.dataReferencia
                ? formatarData(data.dataReferencia)
                : undefined
        }
    ].filter((metrica) => metrica.valor !== undefined);
}

function formatarTipoServidor(tipo) {
    return `${tipo || ""}`
        .toLowerCase()
        .split("_")
        .map((parte) => parte.charAt(0).toUpperCase() + parte.slice(1))
        .join(" ");
}

function formatarTipoMovimentacao(tipo) {
    const descricoes = {
        "01": "01 — Admissão/contratação",
        "02": "02 — Reintegração e equivalentes",
        "03": "03 — Enquadramento/transformação",
        "05": "05 — Cessão recebida",
        "06": "06 — Afastamento sem remuneração",
        "07": "07 — Afastamento com remuneração",
        "08": "08 — Mandato eletivo",
        "09": "09 — Cessão iniciada",
        11: "11 — Retorno sem remuneração",
        12: "12 — Retorno com remuneração",
        13: "13 — Retorno de mandato",
        14: "14 — Retorno de cessão",
        16: "16 — Nomeação em comissão",
        17: "17 — Exoneração de comissão",
        32: "32 — Progressão na carreira"
    };
    return descricoes[tipo] || tipo;
}

function competenciaAtual() {
    const hoje = new Date();
    return `${hoje.getFullYear()}${String(hoje.getMonth() + 1).padStart(
        2,
        "0"
    )}`;
}

function onlyNumbers(value) {
    return value.replace(/\D/g, "");
}

function toOptionalNumber(value) {
    if (value === undefined || value === null || value === "") {
        return undefined;
    }
    return Number(value);
}

function formatarAnoMes(value) {
    if (!isAnoMesValido(value)) {
        return value || "";
    }

    return `${value.slice(4, 6)}/${value.slice(0, 4)}`;
}

function formatarData(value) {
    return new Date(`${value}T00:00:00`).toLocaleDateString("pt-BR");
}

function mensagemErro(error) {
    return (
        error?.message || "Não foi possível carregar os dados da integração."
    );
}

export default IntegracaoFolhaPage;
